'use strict';

const React = require( 'react' );
const propTypes = require('prop-types');
const DateHelper = require( '../../../../_plugins/lib/dateHelper.js' );
const { string } = propTypes;
const createReactClass = require('create-react-class');

const LastUpdated = createReactClass({
  propTypes: {
    id: string,
    lastUpdated: string
  },

  render() {
    const { id, lastUpdated } = this.props;

    if ( typeof lastUpdated === 'undefined' ) return null;

    const daysCycle = 28;
    const updated = new Date( lastUpdated );
    const monthNames = [ 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December' ];
    const dateString = DateHelper.pad( updated.getDate().toString() ) + DateHelper.getOrdinal( updated.getDate() ) + ' ' + monthNames[ updated.getMonth() ] + ' ' + updated.getFullYear().toString();

    return (
      <span id={ id }><small>Last updated on <em>{ dateString }</em></small></span>
    );
  }
});

module.exports = LastUpdated;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/lastUpdated.jsx